import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, forwardRef, Output, EventEmitter } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'demooz-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    imports: [IonIcon, ReactiveFormsModule],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class DemoozInputComponent implements OnInit {

    @Input({alias : 'type', required : true}) typeInput: string = 'text';  
    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = '';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MAIN.MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'autocomplete', required : false}) autocomplete: boolean = false;
    @Input({alias : 'showBtnClearInput', required : false}) showBtnClearInput: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'textAlign', required : false}) textAlign: 'left'|'center'|'right' = 'left';
    @Input({alias : 'min', required : false}) min: number;
    @Input({alias : 'max', required : false}) max: number;
    @Output() onFocusInput = new EventEmitter<any>();
    @Output() onBlurInput = new EventEmitter<any>();

    @ViewChild('demoozInput') demoozInput: ElementRef;

    originalTypeInput: string;
    showPassword: boolean = false;
    isRequired: boolean = false;    
    updateStatusChange: Subscription;

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {
        this.originalTypeInput = this.typeInput;
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required); 
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });        
    }
    
    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }
    
    focusInput(){
        this.demoozInput.nativeElement.focus();
    }
    
    togglePassword(){
        if(this.originalTypeInput === 'password'){
            this.showPassword = !this.showPassword;
            this.typeInput = (this.showPassword ? 'text' : 'password');
        }
    }
        
    clearInput(){
        if(!this.disabled){
            if(this.formGroupDirective.form.controls[this.formName]){
                let value: any = '';
                if(this.typeInput === 'number'){
                    value = 0;
                }
                this.formGroupDirective.form.controls[this.formName].setValue(value);
            }
        }
    }
}
